export const OfficeCompanyProfileState = {
	url: '/company-profile',
	title: 'Office Company Profile',
	template: '<company-profile-page></company-profile-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeCompanyProfilePageMod" */
			'@Containers/office-my-company-page/office-my-company-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
